import { Fragment, useState } from "react";

import { Element } from "@craftjs/core";
import { LayoutPanelTop } from "lucide-react";
import { cn } from "twyne-new.ui";

import { define, variant } from "@/components/builder/utils";

import { GridContainerBlock, GridItemBlock } from "..";
import BasePreview from "../base";

function GridPreview({ properties }) {
  const { grid: { rows, columns } } = properties

  return <BasePreview>
    <div>
      <Element is={GridContainerBlock} id='grid' canvas properties={properties}>
        {Array.from({ length: rows * columns }).map((_, idx) => <Element is={GridItemBlock} canvas key={idx} />)}
      </Element>
    </div>
  </BasePreview>
}

const MAX_COLS = 6
const MAX_ROWS = 6

function VariantPreview({ onChangeProps }) {
  const [hovered, setHovered] = useState([-1, -1])

  const handleChange = (ridx, cidx) => () => {
    setHovered([ridx, cidx])
    onChangeProps({
      grid: {
        rows: ridx + 1,
        columns: cidx + 1,
      },
    })
  }

  return <div className="flex justify-center items-center w-full h-full">
    <div className={`grid grid-cols-${MAX_COLS} gap-1 flex-nowrap`}>
      {Array
        .from({ length: MAX_ROWS })
        .map((_, ridx) => Array
          .from({ length: MAX_COLS })
          .map((_, cidx) => {
            const isHovered = ridx <= hovered[0] && cidx <= hovered[1]

            return <div
              key={`${ridx}-${cidx}`}
              onMouseEnter={handleChange(ridx, cidx)}
              className={cn(`border-[2px] rounded-md p-6 transition-all duration-200`, {
                'border-gray-300 dark:border-gray-400': !isHovered,
                'bg-blue-400/20 dark:bg-blue-400/20': isHovered,
                'border-blue-400/20 dark:border-blue-400/20': isHovered,
              })}
            ></div>
          }))}
    </div>
  </div>
}

export default define('grid', GridPreview, Fragment)
  .variant(variant(VariantPreview, null)
    .add('grid-table', 'Grid Table', { layoutType: 'grid' }, {}))
  .palete(<LayoutPanelTop size={16} />, 'Grid', 'Structures')
  .defaultProps({})
  .build()
